/* Grey Chapel — gc-cart.js
   Drawer, cart mutations, quantities, add to cart, quick add. See docs/gc-cart.md. */
(function () {
  'use strict';
  var GC = window.GC;
  if (!GC) return;

  /* ---------------- Cart drawer ---------------- */

  function drawerRoot() { return document.querySelector('[data-drawer]'); }

  /* #lay75 The open drawer owns one history entry, so a phone's back button closes it
     instead of leaving the page. See docs/gc-cart.md, "The back button closes the drawer". */
  var drawerEntry = false;
  var unwinding = false;
  /* Cart-pick slots rendered into a closed drawer; filled when it opens, so a drawer nobody opens costs no search. */
  var picksWaiting = [];

  function openDrawer() {
    var d = drawerRoot();
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('gc-drawer-lock');
    var tabbar = document.querySelector('.gc-tabbar.is-hidden');
    if (tabbar) tabbar.classList.remove('is-hidden');
    var sticky = document.querySelector('.gc-stickyadd.is-low');
    if (sticky) sticky.classList.remove('is-low');
    if (!drawerEntry && !unwinding && d.hasAttribute('data-drawer-back')) {
      try { history.pushState({ gcDrawer: true }, ''); drawerEntry = true; } catch (err) { /* no history: back leaves */ }
    }
    picksWaiting.splice(0).forEach(function (slot) { if (slot.isConnected) fillPicks(slot); });
  }

  function closeDrawer() {
    var d = drawerRoot();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('gc-drawer-lock');
    if (drawerEntry) { drawerEntry = false; unwinding = true; history.back(); }
  }

  window.addEventListener('popstate', function (e) {
    if (unwinding) {
      unwinding = false;
      var d = drawerRoot();
      if (d && d.classList.contains('is-open')) openDrawer(); // reopened before our back() landed
      return;
    }
    if (drawerEntry && !(e.state && e.state.gcDrawer)) { drawerEntry = false; closeDrawer(); }
  });

  /* Back from checkout or a cart-line link reloads onto our entry; reopen so the next back press isn't dead. */
  var bootDrawer = drawerRoot();
  if (bootDrawer && bootDrawer.hasAttribute('data-drawer-back') && history.state && history.state.gcDrawer) { drawerEntry = true; openDrawer(); }

  /* #9uaus ---------------- Cart mutation plumbing ----------------

     Shopify re-renders up to five sections inside the request that changes the
     cart, and the response carries the cart itself, so one round trip does what
     used to take three. Don't add another. */

  /* The cart as the server last described it. What the shopper has asked for
     since lives in `desired` below, and is laid over this on every paint. */
  var lastCart = null;

  /* #t5wx2 A line thumbnail points at a copy of the same file the page already decoded (gallery slide, tile), so adding to cart costs no image request. */
  function reuseDecodedImages(scope) {
    var file = function (u) { return (u || '').split('?')[0].split('/').pop(); };
    var best = {};
    Array.prototype.forEach.call(document.images, function (img) {
      if (!GC.progressive.decoded(img)) return;
      var src = img.currentSrc || img.src;
      var k = file(src);
      if (k && (!best[k] || img.naturalWidth > best[k].w)) best[k] = { src: src, w: img.naturalWidth };
    });
    Array.prototype.forEach.call(scope.querySelectorAll('.gc-line__media img'), function (img) {
      var hit = best[file(img.getAttribute('src'))];
      if (!hit) return;
      img.removeAttribute('srcset');
      img.setAttribute('src', hit.src);
    });
  }

  function swapDrawer(html, open) {
    /* A <template> parses inertly, so no thumbnail starts downloading before reuseDecodedImages rewrites it. */
    var wrap = document.createElement('template');
    wrap.innerHTML = html;
    var fresh = wrap.content.querySelector('[data-drawer]');
    var current = drawerRoot();
    if (!fresh || !current) return;
    reuseDecodedImages(fresh);
    /* Swap only the panel contents so the open drawer never unmounts
       (replacing the root replays the slide-in transition). */
    var freshPanel = fresh.querySelector('.gc-drawer');
    var panel = current.querySelector('.gc-drawer');
    if (freshPanel && panel) {
      var items = panel.querySelector('.gc-drawer__items');
      var scrollPos = items ? items.scrollTop : 0;

      /* Where the bars actually are this instant, mid-transition. The response
         describes the cart as it was when the request left, so a press made since is
         newer than anything in it — and restoring scrollTop below flushes layout,
         which would otherwise adopt the response's width as the transition's starting
         point. That is the leap forward and slow crawl back: press +, press − inside
         the window, and the bar jumps to full before animating down to half. */
      var live = panel.querySelectorAll('.gc-shipbar__fill');
      var at = [];
      for (var i = 0; i < live.length; i++) at.push(getComputedStyle(live[i]).width);

      panel.innerHTML = freshPanel.innerHTML;

      var fills = panel.querySelectorAll('.gc-shipbar__fill');
      var n = Math.min(fills.length, at.length);
      for (var j = 0; j < n; j++) {
        fills[j].style.transition = 'none';
        fills[j].style.width = at[j];
      }

      items = panel.querySelector('.gc-drawer__items');
      if (items) items.scrollTop = scrollPos;
      /* Per-element setup inside the panel (the cart picks) runs again on the fresh markup. */
      GC.boot(panel);

      /* Handed back after that flush, so the repaint that follows animates from where
         the bar stands rather than from where the response put it. */
      for (var k = 0; k < n; k++) fills[k].style.transition = '';

      if (open) openDrawer();
    } else {
      var wasOpen = current.classList.contains('is-open');
      current.replaceWith(fresh);
      GC.boot(fresh);
      if (wasOpen || open) {
        requestAnimationFrame(function () { requestAnimationFrame(openDrawer); });
      }
    }
  }

  function cartPageRoot() { return document.querySelector('[data-cart-page]'); }

  function swapCartPage(html) {
    var current = cartPageRoot();
    if (!current) return;
    var wrap = document.createElement('div');
    wrap.innerHTML = html;
    var fresh = wrap.querySelector('[data-cart-page]');
    if (fresh) { current.replaceWith(fresh); GC.boot(fresh); }
  }

  /* The cart page id comes off Shopify's own wrapper, not a literal here, so
     renaming the section in templates/cart.json cannot quietly break this. */
  function cartSectionIds() {
    var ids = ['cart-drawer'];
    var cp = cartPageRoot();
    if (cp) {
      var host = cp.closest('[id^="shopify-section-"]');
      if (host) ids.push(host.id.replace('shopify-section-', ''));
    }
    return ids;
  }

  /* #dd9un Read from the markup, not fetched: the first click already knows what it is
     counting from. Re-read after each swap — the drawer re-renders with the cart. */
  function readCartState() {
    var el = document.querySelector('[data-cart-state]');
    if (!el) return;
    try { lastCart = JSON.parse(el.textContent); } catch (e) {}
  }

  /* #rc4u3 What the shopper has asked for and the server has not confirmed, by line key.
     The controls show this, so a response landing mid-flight cannot put the
     one-step-behind figure back under their thumb. Retired once the cart agrees. */
  var desired = {};

  /* Absolute, never accumulated, so it cannot drift however many presses land
     before a response does. */
  function optimisticFigures() {
    if (!lastCart) return null;
    var count = lastCart.item_count;
    var price = lastCart.total_price;
    var noShipCount = 0, noShipPrice = 0;
    (lastCart.items || []).forEach(function (it) {
      var q = it.key in desired ? desired[it.key] : it.quantity;
      // #k7sv2 Gift cards ship nothing, so Shopify's free-shipping rule never counts them; neither does the bar.
      if (it.requires_shipping === false) {
        noShipCount += q;
        noShipPrice += q * (it.final_price || 0);
      }
      if (!(it.key in desired)) return;
      var dq = desired[it.key] - it.quantity;
      count += dq;
      price += dq * (it.final_price || 0);
    });
    return {
      item_count: Math.max(0, count), total_price: Math.max(0, price),
      ship_count: Math.max(0, count - noShipCount), ship_price: Math.max(0, price - noShipPrice)
    };
  }

  /* #118ny The line's own figure moves with its quantity like everything else in here, and was
     the last one still waiting on the server. final_price is the unit the server last
     stated, so this is that number times the quantity under the shopper's thumb — the
     same arithmetic optimisticFigures does for the cart as a whole. Only lines with
     something outstanding are touched; the rest already read what the server sent. */
  function paintLinePrices() {
    if (!lastCart) return;
    var byKey = {};
    (lastCart.items || []).forEach(function (it) { byKey[it.key] = it; });
    document.querySelectorAll('[data-line-price]').forEach(function (el) {
      var line = byKey[el.getAttribute('data-key')];
      if (!line) return;
      /* Outstanding intent where there is any, the server's own figure otherwise. Painting
         only the outstanding ones left a price that had been painted optimistically with
         nothing to correct it whenever no fresh markup followed. */
      var k = el.getAttribute('data-key');
      var qty = (k in desired) ? desired[k] : line.quantity;
      var text = GC.money((line.final_price || 0) * qty);
      if (el.textContent !== text) el.textContent = text;
    });
  }

  /* Puts the steppers back where the server has them. Only the give-up path needs it:
     paintQtyGroup is otherwise driven from `desired`, so once that is emptied nothing
     would move a control off the press that never landed, and the next press would be
     taken one step from a number the cart never accepted. */
  function restoreControls(keys) {
    if (!lastCart) return;
    var byKey = {};
    (lastCart.items || []).forEach(function (it) { byKey[it.key] = it; });
    keys.forEach(function (k) {
      var line = byKey[k];
      if (!line) return;
      document.querySelectorAll('[data-key="' + k + '"]').forEach(function (el) {
        var group = el.closest('.gc-qty');
        if (group) paintQtyGroup(group, line.quantity);
      });
    });
  }

  function paintOptimistic() {
    var f = optimisticFigures();
    if (!f) return;
    paintShipProgress(f);
    paintMoney(f);
    paintLinePrices();
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = f.item_count;
      var box = el.closest('[data-cart-count-box]');
      if (box) box.hidden = f.item_count === 0;
    });
  }

  function paintCart(cart) {
    if (!cart) return;
    lastCart = cart;
    var items = cart.items || [];
    Object.keys(desired).forEach(function (k) {
      var line = null;
      for (var i = 0; i < items.length; i++) {
        if (items[i].key === k) { line = items[i]; break; }
      }
      /* Agreed with, or gone because going was what we asked for. Settled. */
      if (line ? line.quantity === desired[k] : desired[k] === 0) delete desired[k];
    });
    paintOptimistic();
  }

  /* Takes FormData straight off the product form: rebuilding it as JSON would mean
     re-deriving properties[], selling plans and quantity by hand. */
  function cartMutate(path, body, open) {
    var opts = { method: 'POST', headers: { 'Accept': 'application/json' } };
    if (window.FormData && body instanceof FormData) {
      /* No sections_url here. Shopify accepts it in a JSON body but rejects the same
         string as a form field ("must be a relative path" for a plain "/cart").
         Omitted, it falls back to the Referer, which is the page we are on. */
      body.append('sections', cartSectionIds().join(','));
      opts.body = body;
    } else {
      body.sections = cartSectionIds();
      body.sections_url = window.location.pathname;
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }
    return fetch(GC.root + path, opts)
      .then(function (r) {
        /* #z36gj Shopify answers a rate limit or a server error with an HTML page, so the body
           cannot be assumed to be JSON. Parsing it as JSON threw a SyntaxError about an
           unexpected '<', which the add-to-cart path then put in front of the shopper
           verbatim. Read it as text and decide afterwards. */
        return r.text().then(function (body) {
          var data = null;
          try { data = JSON.parse(body); } catch (e) {}
          if (!r.ok || !data) {
            throw new Error((data && data.description) || 'Could not update the cart');
          }
          return data;
        });
      })
      .then(function (data) {
        var sections = data.sections || {};
        Object.keys(sections).forEach(function (id) {
          if (!sections[id]) return;
          if (id === 'cart-drawer') swapDrawer(sections[id], open);
          else swapCartPage(sections[id]);
        });
        /* add.js answers with the line item, which carries no counts; the drawer in
           the same response has them. Runs before the repaint because it is what
           retires settled entries from `desired`. cart.js is the last resort. */
        if (typeof data.item_count === 'number') {
          paintCart(data);
        } else {
          readCartState();
          if (lastCart) paintCart(lastCart);
          else updateCount();
        }
        /* Whatever survived that pruning is a change made while this request was
           in flight, so it goes back over the markup that has just replaced it. */
        applyDesiredToDom();
        return data;
      });
  }

  /* ---------------- Quantity changes ----------------

     The control is the source of truth: a press lands in `desired`, paints at once,
     is debounced, and is laid back over whatever markup returns. Without that last
     step a response arriving behind a newer press makes the number count backwards.

     Lines are addressed by key, never index — removing a line renumbers the rest.

     The long pause belongs to the stepper alone. Walking − down to zero can be a slip
     worth taking back, so that one waits. Remove is a decision, not a slip, and typing
     a number is the same — both go at once. While Remove shared the stepper's delay it
     read as a dead control: it sits outside .gc-qty so there is no group to repaint,
     and every impatient re-tap pushed the deadline out again, so the harder it was
     pressed the less it did. */

  var QTY_DEBOUNCE = 200;
  var QTY_DEBOUNCE_REMOVE = 1200;
  var qtyTimer = null;
  var qtyBusy = false;
  var qtyFails = 0;
  var QTY_TRIES = 3;

  function paintQtyGroup(group, qty) {
    if (!group) return;
    var span = group.querySelector('span');
    if (span) span.textContent = qty;
    var input = group.querySelector('[data-qty-input]');
    if (input) input.value = qty;
    var dec = group.querySelector('[aria-label="Decrease"]');
    var inc = group.querySelector('[aria-label="Increase"]');
    if (dec) dec.setAttribute('data-qty', Math.max(0, qty - 1));
    if (inc) inc.setAttribute('data-qty', qty + 1);
  }

  /* Re-assert outstanding intent over markup that has just been replaced. Both
     carts can be showing the same line, so every match is repainted. */
  function applyDesiredToDom() {
    Object.keys(desired).forEach(function (k) {
      var els = document.querySelectorAll('[data-key="' + k + '"]');
      Array.prototype.forEach.call(els, function (el) {
        paintQtyGroup(el.closest('.gc-qty'), desired[k]);
      });
    });
  }

  function scheduleFlush(delay) {
    if (qtyTimer) clearTimeout(qtyTimer);
    qtyTimer = setTimeout(flushQty, typeof delay === 'number' ? delay : QTY_DEBOUNCE);
  }

  /* The row leaves when the request leaves, not when the answer arrives. The long pause
     above is the undo; once it has passed and the removal is on the wire the decision is
     made, and Shopify is already dropping the line. A row left sitting there with live
     controls for the length of a round trip invites a press that cannot land — the key it
     would address no longer exists, so + painted a 1 the cart was never going to agree
     with. Put back only if the write fails, because then the line really is still there. */
  function showRow(keys, shown) {
    keys.forEach(function (k) {
      document.querySelectorAll('[data-key="' + k + '"]').forEach(function (el) {
        var row = el.closest('.gc-line');
        if (row) row.hidden = !shown;
      });
    });
  }

  function flushQty() {
    qtyTimer = null;
    if (qtyBusy) return;
    var keys = Object.keys(desired);
    if (!keys.length) return;
    var updates = {};
    var going = [];
    keys.forEach(function (k) {
      updates[k] = desired[k];
      if (desired[k] === 0) going.push(k);
    });
    qtyBusy = true;
    showRow(going, false);
    cartMutate('cart/update.js', { updates: updates })
      .then(function () { qtyFails = 0; }, function (err) {
        /* Swallowed whole until now: a rejected write left the pressed number on screen
           with nothing behind it, and the checkout that followed disagreed. Reported the
           way GC.safe reports so it reaches Clarity, but not re-thrown into the chain —
           the retry below is the recovery and it has to keep running. The row is left
           hidden between attempts: showing it again each time is what made a line blink
           in and out while the cart sat at nought. */
        qtyFails++;
        GC.safe(function () { throw err; });
      })
      .then(function () {
        qtyBusy = false;
        /* Anything the response did not settle is a change made while it was in
           flight, so it needs a request of its own. */
        if (!Object.keys(desired).length) return;
        if (!qtyFails) { scheduleFlush(); return; }
        /* Backing off rather than hammering: this used to reschedule unconditionally, so
           a write that could not succeed retried every 200ms for as long as the drawer
           was open. */
        if (qtyFails < QTY_TRIES) { scheduleFlush(QTY_DEBOUNCE * qtyFails * 2); return; }
        /* Out of tries. The intent never reached the cart, so the cart is right and we
           are wrong: put the rows back and repaint from the server's last word rather
           than leave figures on screen that nothing stands behind. */
        qtyFails = 0;
        showRow(going, true);
        var stale = Object.keys(desired);
        desired = {};
        if (lastCart) paintCart(lastCart);
        restoreControls(stale);
      });
  }

  function setLineQty(key, qty, group, delay) {
    if (!key || isNaN(qty) || qty < 0) return;
    desired[key] = qty;
    paintQtyGroup(group, qty);
    paintOptimistic();
    scheduleFlush(delay);
  }


  /* Substitutes into the wording snippets/free-ship-progress.liquid supplies as a
     data attribute template. The copy is never duplicated here. */
  /* The only place the free-shipping goal is tested; each element carries its own data-goal/data-mode. null means no goal set. */
  function shipLeft(el, cart) {
    var goal = parseInt(el.getAttribute('data-goal'), 10);
    if (!goal) return null;
    var have = el.getAttribute('data-mode') === 'items' ? cart.ship_count : cart.ship_price;
    return goal - have;
  }

  function paintShipProgress(cart) {
    document.querySelectorAll('[data-shipprog]').forEach(function (el) {
      var left = shipLeft(el, cart);
      if (left === null) return;
      var goal = parseInt(el.getAttribute('data-goal'), 10);
      var items = el.getAttribute('data-mode') === 'items';
      var have = items ? cart.ship_count : cart.ship_price;
      var text;
      if (left <= 0) {
        text = el.getAttribute('data-done');
      } else if (items) {
        var noun = el.getAttribute(left === 1 ? 'data-noun' : 'data-noun-plural');
        text = el.getAttribute('data-msg').replace('{count}', left).replace('{noun}', noun);
      } else {
        text = el.getAttribute('data-msg').replace('{amount}', GC.money(left));
      }
      var msg = el.querySelector('[data-shipprog-msg]');
      if (msg && msg.textContent !== text) msg.textContent = text;
      /* Only ever written when it actually moves. The fill carries a .4s width
         transition, so re-asserting the width it already holds — which is what a
         server response confirming what we already painted amounts to — restarts
         the animation and reads as the bar snapping back to where it stands. */
      var fill = el.querySelector('.gc-shipbar__fill');
      var width = Math.min(100, Math.round(have * 100 / goal)) + '%';
      if (fill && fill.style.width !== width) fill.style.width = width;
      el.classList.toggle('is-met', left <= 0);
      // #f5k2t The product page's tag waits for a first shirt in the cart; the drawer and cart page bars always show.
      if (el.classList.contains('gc-shiptag')) el.hidden = cart.ship_count === 0;
    });
  }

  /* #2z9ir The subtotal and the checkout button's figure move on the press, not a debounce and a round trip later; the response overwrites them either way. */
  function paintMoney(f) {
    var sub = GC.money(f.total_price);
    document.querySelectorAll('[data-cartsum-subtotal], [data-checkout-fig]').forEach(function (el) {
      if (el.textContent !== sub) el.textContent = sub;
    });
  }

  /* The fallback path, for callers that changed the cart without asking for it
     back. Bundled mutations do not come through here. */
  function updateCount() {
    return fetch(GC.root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(paintCart);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-open]')) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawer(); return; }

    // #h4n8c A drawer link to the product and variant already on screen only closes; loading it would land on the drawer entry and reopen.
    var self = e.target.closest('[data-drawer] a[href]');
    if (self && !(e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || e.button) && !self.target &&
        self.origin === location.origin && self.pathname === location.pathname) {
      var want = new URLSearchParams(self.search).get('variant');
      var picked = document.querySelector('[data-product-form] [data-variant-id]');
      var have = picked ? picked.value : new URLSearchParams(location.search).get('variant');
      if (!want || want === have) { e.preventDefault(); closeDrawer(); return; }
    }

    var qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      e.preventDefault();
      /* Remove sits outside the +/- group, so there is not always one to repaint. That
         is also what tells the two apart: only a press inside .gc-qty labelled Decrease
         is the stepper reaching zero, and only that one earns the undo window. */
      var group = qtyBtn.closest('.gc-qty');
      var qty = parseInt(qtyBtn.getAttribute('data-qty'), 10);
      var delay = QTY_DEBOUNCE;
      if (qty === 0) {
        delay = (group && qtyBtn.getAttribute('aria-label') === 'Decrease') ? QTY_DEBOUNCE_REMOVE : 0;
      }
      setLineQty(qtyBtn.getAttribute('data-key'), qty, group, delay);
    }
  });

  /* #wme40 Not disabled the way the buttons are: a disabled field is left out of the POST
     entirely, so a form submission landing mid-flight would drop that line. */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (!input) return;
    setLineQty(
      input.getAttribute('data-key'),
      parseInt(input.value, 10),
      input.closest('.gc-qty')
    );
  });

  /* The change handler above has already applied it, so the round trip is redundant.
     Checkout is never blocked, nor is a browser too old to report a submitter. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.querySelector || !form.querySelector('[data-qty-input]')) return;
    if (!e.submitter || e.submitter.name !== 'update') return;
    e.preventDefault();
  });

  /* #a0vif The drawer's checkout form carries no updates[] of its own, so it posts whatever the
     server still holds, and a press still inside scheduleFlush's debounce has not reached it
     yet. Sending the outstanding intent along with the navigation closes that window without
     making anyone wait on a request that was already going out. desired is pruned against
     the server in paintCart, so it is exactly the set the cart has not acknowledged.

     The cart page is excluded by its own [data-qty-input]: its fields already post updates[<key>]
     for every line, so nothing is outstanding that they do not carry. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.querySelector) return;
    if (!form.querySelector('[name="checkout"]')) return;
    if (form.querySelector('[data-qty-input]')) return;
    var keys = Object.keys(desired);
    if (!keys.length) return;
    if (qtyTimer) { clearTimeout(qtyTimer); qtyTimer = null; }
    keys.forEach(function (k) {
      var hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'updates[' + k + ']';
      hidden.value = desired[k];
      form.appendChild(hidden);
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* Seeds the figures the optimistic repaint counts from. Liquid already printed
     them into the page, so this costs nothing. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', readCartState);
  } else readCartState();

  /* ---------------- Add to cart (product form) ---------------- */

  function addToCart(body) {
    return cartMutate('cart/add.js', body, true);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    // #v3qm8 A submit dispatched by script skips the browser's checks, so a required field (a gift card's recipient email) is checked here.
    if (form.checkValidity && !form.checkValidity()) { if (form.reportValidity) form.reportValidity(); return; }
    /* The sticky bar carries a second [data-add-btn] outside the form, so both
       have to show progress. */
    var scope = form.closest('[data-product]') || form;
    var btns = scope.querySelectorAll('[data-add-btn]');
    btns.forEach(function (btn) {
      btn.disabled = true;
      btn.dataset.prevText = btn.innerHTML;
      btn.textContent = 'Adding…';
    });
    addToCart(new FormData(form))
      .catch(function (err) { alert(err.message); })
      .finally(function () {
        btns.forEach(function (btn) {
          btn.disabled = false;
          if (btn.dataset.prevText) btn.innerHTML = btn.dataset.prevText;
        });
      });
  });

  /* #n1c7u ---------------- Add a second shirt ----------------
     With one shirt in the cart, the slot asks the related finder for three designs sharing its
     title words or tags. Each shows the rendition this visit already has, and Add puts it in at
     the cart shirt's size. See docs/cart-picks.md. */
  var PICKS = 6, pickFinds = {}, pickVariants = {};

  /* PDP pages ship gc-related.js; every other page prefetched it at idle, so loading it here is a cache hit. */
  function relatedModule() {
    if (GC.related) return Promise.resolve(GC.related);
    return new Promise(function (resolve, reject) {
      var t = setTimeout(function () { reject(new Error('gc-related.js did not report in')); }, 8000);
      GC.on('related:ready', function (R) { clearTimeout(t); resolve(R); });
      if (document.querySelector('script[src*="gc-related"]')) return;
      var src = (window.GC_PREFETCH || []).filter(function (u) { return /gc-related/.test(u); })[0];
      if (!src) { clearTimeout(t); reject(new Error('gc-related.js is not on this page and has no prefetch URL')); return; }
      var s = document.createElement('script');
      s.src = src;
      s.async = true;
      s.onerror = function () { clearTimeout(t); reject(new Error('gc-related.js failed to load')); };
      document.head.appendChild(s);
    });
  }

  function variantOf(href) {
    var m = /[?&]variant=(\d+)/.exec(href || '');
    return m ? m[1] : '';
  }

  /* The rendition this visit already decoded, in that colour; failing that, the pool card's own
     image and colourway at a width small enough for the pick. */
  function pickImage(handle, card) {
    var seen = GC.seen ? GC.seen(handle) : null, link = card.querySelector('a[href*="/products/"]');
    var cardVariant = variantOf(link && link.getAttribute('href'));
    if (seen) return { src: seen[0], variant: seen[1] || cardVariant };
    var img = card.querySelector('.gc-card-media img'), src = img ? img.getAttribute('src') || '' : '';
    var want = Math.min(360, Math.ceil(120 * (window.devicePixelRatio || 1) / 60) * 60);
    return { src: src.replace(/([?&]width=)\d+/, '$1' + want), variant: cardVariant };
  }

  function buildPick(cand, size) {
    var handle = cand.getAttribute('data-gc-handle'), card = cand.firstElementChild, im = pickImage(handle, card);
    var nameEl = card.querySelector('.gc-card-name'), priceEl = card.querySelector('.gc-card-price');
    var href = GC.root + 'products/' + handle + (im.variant ? '?variant=' + im.variant : '');
    var el = document.createElement('div');
    el.className = 'gc-pick';
    var media = document.createElement('a');
    media.className = 'gc-pick__media';
    media.href = href;
    media.tabIndex = -1;
    media.setAttribute('aria-hidden', 'true');
    if (im.src) {
      var img = document.createElement('img');
      img.src = im.src;
      img.alt = '';
      img.decoding = 'async';
      media.appendChild(img);
    }
    var name = document.createElement('a');
    name.className = 'gc-pick__name';
    name.href = href;
    name.textContent = (nameEl ? nameEl.textContent : cand.getAttribute('data-gc-title')).trim();
    var price = document.createElement('span');
    price.className = 'gc-pick__price';
    price.textContent = priceEl ? priceEl.textContent.trim() : '';
    var add = document.createElement('button');
    add.type = 'button';
    add.className = 'gc-btn gc-btn--block gc-pick__add';
    add.setAttribute('data-pick-add', '');
    add.setAttribute('data-handle', handle);
    add.setAttribute('data-variant', im.variant || '');
    add.setAttribute('data-size', size || '');
    add.textContent = size ? 'Add · ' + size : 'Add';
    add.setAttribute('aria-label', 'Add ' + name.textContent + (size ? ', size ' + size : ''));
    el.appendChild(media);
    el.appendChild(name);
    el.appendChild(price);
    el.appendChild(add);
    return el;
  }

  /* A few hundred bytes per design, and only for the picks on screen. */
  function variantsFor(handle) {
    if (!pickVariants[handle]) {
      pickVariants[handle] = fetch(GC.root + 'products/' + handle + '?section_id=cart-pick')
        .then(function (r) {
          if (!r.ok) throw new Error('cart-pick for ' + handle + ' answered ' + r.status);
          return r.text();
        })
        .then(function (t) {
          var w = document.createElement('template');
          w.innerHTML = t;
          var s = w.content.querySelector('[data-cart-pick]');
          if (!s) throw new Error('cart-pick: no variant table for ' + handle);
          return JSON.parse(s.textContent);
        });
      pickVariants[handle].catch(function () { delete pickVariants[handle]; });
    }
    return pickVariants[handle];
  }

  /* The shown colour in the cart shirt's size, available; null sends the shopper to the design to choose. */
  function pickVariant(list, variantId, size) {
    var colour = null, i;
    for (i = 0; i < list.length; i++) if (String(list[i].id) === String(variantId)) colour = list[i].c;
    for (i = 0; i < list.length; i++) {
      var v = list[i];
      if (v.a && (colour === null || v.c === colour) && (!size || v.s === size)) return v;
    }
    return null;
  }

  function checkPick(btn) {
    var handle = btn.getAttribute('data-handle');
    variantsFor(handle).then(function (list) {
      if (!pickVariant(list, btn.getAttribute('data-variant'), btn.getAttribute('data-size'))) {
        btn.textContent = 'Choose size';
        btn.setAttribute('data-pick-choose', '');
        btn.setAttribute('aria-label', 'Choose a size for ' + handle.replace(/-/g, ' '));
      }
    }, function (err) { console.warn('gc-cart: could not read variants for ' + handle, err); });
  }

  function fillPicks(slot) {
    var drawer = slot.closest('[data-drawer]');
    if (drawer && !drawer.classList.contains('is-open')) {
      if (picksWaiting.indexOf(slot) === -1) picksWaiting.push(slot);
      return;
    }
    slot.hidden = false;
    var handle = slot.getAttribute('data-gc-handle');
    if (!pickFinds[handle]) {
      pickFinds[handle] = relatedModule().then(function (R) {
        return R.find({
          title: slot.getAttribute('data-gc-title'), tags: slot.getAttribute('data-gc-tags'),
          ignore: slot.getAttribute('data-gc-ignore'), base: slot.getAttribute('data-url'),
          section: 'related-tag-pool', slots: PICKS, exclude: [handle],
          valid: function (n) { return !!n.firstElementChild; }
        });
      });
      pickFinds[handle].catch(function () { delete pickFinds[handle]; });
    }
    pickFinds[handle].then(function (cands) {
      if (!slot.isConnected) return;
      if (!cands.length) { slot.hidden = true; return; }
      var row = slot.querySelector('[data-cart-picks-row]'), size = slot.getAttribute('data-size');
      row.innerHTML = '';
      cands.forEach(function (c) { row.appendChild(buildPick(c, size)); });
      Array.prototype.forEach.call(row.querySelectorAll('[data-pick-add]'), checkPick);
    }, function (err) {
      console.error('gc-cart: cart picks failed', err);
      if (slot.isConnected) slot.hidden = true;
    });
  }
  GC.register('[data-cart-picks]', fillPicks);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-pick-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var pick = btn.closest('.gc-pick'), link = pick && pick.querySelector('a');
    if (btn.hasAttribute('data-pick-choose')) { if (link) window.location.href = link.href; return; }
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    variantsFor(btn.getAttribute('data-handle')).then(function (list) {
      var v = pickVariant(list, btn.getAttribute('data-variant'), btn.getAttribute('data-size'));
      if (!v) { if (link) window.location.href = link.href; return; }
      var fd = new FormData();
      fd.append('id', v.id);
      fd.append('quantity', '1');
      return addToCart(fd);
    }).catch(function (err) { alert(err.message); })
      .finally(function () {
        if (btn.isConnected) { btn.disabled = false; btn.textContent = label; }
      });
  });

  /* ---------------- Quick add (product cards) ---------------- */

  function closeQuickAddTrays() {
    document.querySelectorAll('.gc-qa__sizes:not([hidden])').forEach(function (t) { t.setAttribute('hidden', ''); });
    document.querySelectorAll('[data-qa-open][aria-expanded="true"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }

  function qaMatrix(qa) {
    var el = qa.querySelector('[data-qa-variants]');
    return el ? JSON.parse(el.textContent) : null;
  }

  /* Point the confirm button at the variant matching the selected chips.
     Unknown or unavailable combos turn the button into "Sold out". */
  function qaResolve(qa) {
    var list = qaMatrix(qa);
    var btn = qa.querySelector('[data-qa-open]');
    if (!list || !btn) return;
    var c = qa.getAttribute('data-qa-sel-color');
    var s = qa.getAttribute('data-qa-sel-size');
    var label = btn.querySelector('.gc-qa__btn-label');

    /* Preselection turned off: never guess a variant — keep prompting until the
       customer has picked from every row the tray actually shows. */
    if (btn.hasAttribute('data-qa-needs')) {
      var needsColor = qa.querySelector('[data-qa-color]') && !c;
      var needsSize = qa.querySelector('[data-qa-size]') && !s;
      if (needsColor || needsSize) {
        btn.removeAttribute('data-variant-id');
        btn.classList.add('is-off');
        if (label) label.textContent = btn.getAttribute('data-qa-select-label') || 'Select options';
        return;
      }
    }

    var m = list.find(function (v) {
      return (v.c === null || v.c === c) && (v.s === null || v.s === s);
    });
    if (m && m.a) {
      btn.setAttribute('data-variant-id', m.id);
      btn.classList.remove('is-off');
      if (label) label.textContent = btn.getAttribute('data-qa-label');
    } else {
      btn.removeAttribute('data-variant-id');
      btn.classList.add('is-off');
      if (label) label.textContent = 'Sold out';
    }
  }

  function qaAdd(btn) {
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    var fd = new FormData();
    fd.append('id', id);
    fd.append('quantity', '1');
    var label = btn.querySelector('.gc-qa__btn-label') || btn;
    var prev = label.textContent;
    btn.disabled = true; label.textContent = '…';
    addToCart(fd)
      .then(closeQuickAddTrays)
      .catch(function (err) { alert(err.message); })
      .finally(function () { btn.disabled = false; label.textContent = prev; });
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-qa-open]');
    if (open) {
      e.preventDefault();
      var tray = open.closest('[data-qa]').querySelector('.gc-qa__sizes');
      if (tray && tray.hasAttribute('hidden')) {
        closeQuickAddTrays();
        tray.removeAttribute('hidden');
        open.setAttribute('aria-expanded', 'true');
      } else {
        qaAdd(open);
      }
      return;
    }
    var colorBtn = e.target.closest('[data-qa-color]');
    if (colorBtn) {
      e.preventDefault();
      var qa = colorBtn.closest('[data-qa]');
      var color = colorBtn.getAttribute('data-qa-color');
      qa.setAttribute('data-qa-sel-color', color);
      qa.querySelectorAll('[data-qa-color]').forEach(function (b) {
        b.classList.toggle('is-selected', b === colorBtn);
      });
      var list = qaMatrix(qa);
      if (list) {
        var sizeBtns = qa.querySelectorAll('[data-qa-size]');
        var selectedOff = false;
        sizeBtns.forEach(function (sb) {
          var m = list.find(function (v) { return v.c === color && v.s === sb.getAttribute('data-qa-size'); });
          sb.disabled = !m || !m.a;
          sb.classList.toggle('is-off', sb.disabled);
          if (sb.disabled && sb.classList.contains('is-selected')) selectedOff = true;
        });
        if (selectedOff) {
          var firstOn = Array.prototype.find.call(sizeBtns, function (sb) { return !sb.disabled; });
          sizeBtns.forEach(function (sb) { sb.classList.toggle('is-selected', sb === firstOn); });
          if (firstOn) qa.setAttribute('data-qa-sel-size', firstOn.getAttribute('data-qa-size'));
        }
      }
      qaResolve(qa);
      return;
    }
    var sizeBtn = e.target.closest('[data-qa-size]');
    if (sizeBtn) {
      e.preventDefault();
      var qa2 = sizeBtn.closest('[data-qa]');
      qa2.setAttribute('data-qa-sel-size', sizeBtn.getAttribute('data-qa-size'));
      qa2.querySelectorAll('[data-qa-size]').forEach(function (b) {
        b.classList.toggle('is-selected', b === sizeBtn);
      });
      qaResolve(qa2);
      return;
    }
    var add = e.target.closest('[data-qa-add]');
    if (add) { e.preventDefault(); qaAdd(add); return; }
    if (!e.target.closest('[data-qa]')) closeQuickAddTrays();
  });
})();
